import { API_URL, AWS_BUCKET_URL } from 'settings';

export function getAvatarPath(path) {
  return `${API_URL}/avatar/${path}`;
}

export function getAwsBucketPath(path) {
  return `${AWS_BUCKET_URL}/${path}`;
}
